


























































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ObatComboField from "../lembar-permintaan/ObatComboField.vue";
import OrderEmergensiSvc from "@/services/OrderEmergensi";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import { storePerawat } from "@/store/modules/perawat";
import { storePasien } from "@/store/modules/pasien";
import { refResepStore } from "@/store/modules/ReferensiResep";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import {
  DepoEmergensiResolved,
  OrderEmergensi,
  OrderEmergensiPayload,
  PaketObatEmergensi
} from "@/types/order_emergensi";
import { buatUuid, formatJumlah, INDIKASI_DEFAULT } from "./orderEmergensi.config";

interface FormItem {
  uid: string;
  id: number | null;
  paket_item_id: number | null;
  kd_obat: string | null;
  nama_obat: string;
  satuan: string | null;
  is_bmhp: boolean;
  ham_lasa: string | null;
  dosis: string | null;
  resep_rute_id: number | null;
  rute_text: string | null;
  jml_standar: number | null;
  jml_digunakan: number | string | null;
  catatan: string | null;
}

@Component({
  components: { ObatComboField }
})
export default class OrderEmergensiForm extends Vue {
  @Prop({ required: true }) register!: string;
  @Prop({ type: String, default: "ranap" }) konteks!: string;
  @Prop({ default: null }) paket!: PaketObatEmergensi | null;
  @Prop({ default: null }) order!: OrderEmergensi | null;
  @Prop({ type: Boolean, default: false }) readonly!: boolean;

  formatJumlah = formatJumlah;

  saving = false;
  loadingDepo = false;
  depo: DepoEmergensiResolved | null = null;
  errors: Record<string, string | null> = {
    indikasi: null,
    alergi_detail: null,
    items: null
  };

  form = {
    client_request_id: "",
    paket_id: null as number | null,
    indikasi: "",
    dpjp_id: null as number | null,
    pemberi_user_id: null as number | null,
    verifikator_user_id: null as number | null,
    diagnosa: "",
    has_alergi: null as boolean | null,
    alergi_detail: "",
    catatan: "",
    items: [] as FormItem[]
  };

  get paketNama(): string | null {
    if (this.order) return this.order.paket_nama;
    return this.paket ? this.paket.nama : null;
  }

  get dokterList() {
    return storeDokter.listAll;
  }

  get daftarPerawat() {
    return storePerawat.listPerawat;
  }

  get daftarPemberi() {
    const saya = { id: userModule.user.id, nama: userModule.user.nama };
    const lain = storePerawat.listPerawat.filter(p => p.id !== saya.id);
    const tersimpan = this.order && this.order.pemberi && this.order.pemberi.id !== saya.id ? [this.order.pemberi] : [];
    return [saya, ...tersimpan, ...lain];
  }

  get refRute() {
    return refResepStore.refRute;
  }

  get jenisBayar(): string {
    if (this.order) return this.order.jenis_bayar || "";
    const pasien: any = storePasien.identitasPasien;
    return pasien?.register?.asr?.nama || "";
  }

  get adaStandar(): boolean {
    return this.form.items.some(i => i.jml_standar !== null);
  }

  get adaHighAlert(): boolean {
    return this.form.items.some(i => i.ham_lasa == "1" && Number(i.jml_digunakan) > 0);
  }

  get lokasiUnitId(): string {
    const reg: any = RegisterKunjungan.register;
    if (!reg) return String(userModule.user.unit_id || "");
    if (this.konteks === "ranap") return String(reg.unit);
    return (reg.unit_asal || reg.unit) === "01" ? "01" : String(reg.unit);
  }

  created() {
    this.resetForm();
    if (this.order) {
      this.populateForm(this.order);
    } else {
      this.isiDariPaket(this.paket);
      this.autoFill();
    }
  }

  mounted() {
    if (!storeDokter.listAll.length) storeDokter.act_dokter_all();
    if (!storePerawat.listPerawat.length) storePerawat.actListPerawatall();
    if (!refResepStore.refRute.length) refResepStore.getRefRute();

    if (this.order) {
      this.depo = {
        kd_depo_stok: this.order.kd_depo_stok,
        kd_depo_layanan: this.order.kd_depo_layanan,
        depo_sumber: this.order.depo_sumber,
        nama_depo_stok: this.order.nama_depo_stok,
        nama_depo_layanan: this.order.nama_depo_layanan
      };
    } else {
      this.muatDepo();
    }
  }

  resetForm() {
    this.form = {
      client_request_id: buatUuid(),
      paket_id: null,
      indikasi: INDIKASI_DEFAULT,
      dpjp_id: null,
      pemberi_user_id: userModule.user.id,
      verifikator_user_id: null,
      diagnosa: "",
      has_alergi: null,
      alergi_detail: "",
      catatan: "",
      items: []
    };
    this.errors = { indikasi: null, alergi_detail: null, items: null };
  }

  itemKosong(): FormItem {
    return {
      uid: buatUuid(),
      id: null,
      paket_item_id: null,
      kd_obat: null,
      nama_obat: "",
      satuan: null,
      is_bmhp: false,
      ham_lasa: null,
      dosis: null,
      resep_rute_id: null,
      rute_text: null,
      jml_standar: null,
      jml_digunakan: null,
      catatan: null
    };
  }

  isiDariPaket(paket: PaketObatEmergensi | null) {
    if (!paket) {
      this.form.items = [this.itemKosong()];
      return;
    }
    this.form.paket_id = paket.id;
    this.form.indikasi = paket.indikasi || INDIKASI_DEFAULT;
    this.form.items = (paket.items || []).map(p => ({
      ...this.itemKosong(),
      paket_item_id: p.id || null,
      kd_obat: p.kd_obat,
      nama_obat: p.nama_obat,
      satuan: p.satuan,
      is_bmhp: p.is_bmhp,
      dosis: p.dosis,
      resep_rute_id: p.resep_rute_id,
      rute_text: p.rute_text,
      jml_standar: p.jml_standar
    }));
  }

  populateForm(order: OrderEmergensi) {
    this.form = {
      client_request_id: "",
      paket_id: order.paket_id,
      indikasi: order.indikasi,
      dpjp_id: order.dpjp ? order.dpjp.id : null,
      pemberi_user_id: order.pemberi ? order.pemberi.id : null,
      verifikator_user_id: order.verifikator ? order.verifikator.id : null,
      diagnosa: order.diagnosa || "",
      has_alergi: order.has_alergi,
      alergi_detail: order.alergi_detail || "",
      catatan: order.catatan || "",
      items: order.items.map(i => ({
        ...this.itemKosong(),
        id: i.id,
        paket_item_id: i.paket_item_id,
        kd_obat: i.kd_obat,
        nama_obat: i.nama_obat,
        satuan: i.satuan,
        is_bmhp: i.is_bmhp,
        ham_lasa: i.ham_lasa,
        dosis: i.dosis,
        resep_rute_id: i.resep_rute_id,
        rute_text: i.rute_text || null,
        jml_standar: i.jml_standar,
        jml_digunakan: i.jml_digunakan,
        catatan: i.catatan
      }))
    };
  }

  autoFill() {
    const reg: any = RegisterKunjungan.register;
    if (reg?.dokter?.id) this.form.dpjp_id = reg.dokter.id;

    const pasien: any = storePasien.identitasPasien;
    if (pasien?.alergi) {
      this.form.has_alergi = true;
      this.form.alergi_detail = pasien.alergi;
    }

    if (this.konteks === "ranap") {
      const asesmen: any = AsesmenAwalRanapMedisStore.asesmen;
      if (asesmen?.diagnosis) this.form.diagnosa = asesmen.diagnosis;
    } else {
      const gadar: any = AsesmenGadarMedisStore.inputFields;
      if (gadar?.diagnosis_kerja) this.form.diagnosa = gadar.diagnosis_kerja;
    }
  }

  async muatDepo() {
    if (!this.lokasiUnitId) return;
    this.loadingDepo = true;
    try {
      const resp = await OrderEmergensiSvc.resolveDepo(
        this.register,
        this.lokasiUnitId,
        userModule.user.zona || null
      );
      this.depo = resp.data.data;
    } catch {
      this.depo = null;
    } finally {
      this.loadingDepo = false;
    }
  }

  namaRute(id: number | null): string | null {
    if (!id) return null;
    const rute = this.refRute.find(r => Number(r.id) === Number(id));
    return rute ? rute.nama : null;
  }

  rowClass(item: FormItem): string {
    if (Number(item.jml_digunakan) > 0) return "baris-dipakai";
    return "";
  }

  pilihObat(item: FormItem, obat: any) {
    if (!obat || typeof obat !== "object") return;
    item.kd_obat = obat.id || null;
    item.satuan = obat.satuan || null;
    item.ham_lasa = obat.ham_lasa != null ? String(obat.ham_lasa) : null;
    item.is_bmhp = obat.group_ === "ALK";
  }

  isiStandar() {
    this.form.items.forEach(i => {
      if (i.jml_standar !== null) i.jml_digunakan = i.jml_standar;
    });
  }

  tambahItem() {
    this.form.items.push(this.itemKosong());
  }

  hapusItem(idx: number) {
    this.form.items.splice(idx, 1);
  }

  validasi(): boolean {
    this.errors = { indikasi: null, alergi_detail: null, items: null };

    if (!this.form.indikasi || !this.form.indikasi.trim()) {
      this.errors.indikasi = "Indikasi wajib diisi";
    }
    if (this.form.has_alergi && !this.form.alergi_detail.trim()) {
      this.errors.alergi_detail = "Detail alergi wajib diisi";
    }

    const tanpaKode = this.form.items.filter(i => !i.kd_obat);
    const dipakai = this.form.items.filter(i => Number(i.jml_digunakan) > 0);
    const negatif = this.form.items.filter(i => Number(i.jml_digunakan) < 0);

    if (!this.form.items.length) {
      this.errors.items = "Tambahkan minimal satu obat/BMHP";
    } else if (tanpaKode.length) {
      this.errors.items = "Pilih obat dari daftar pencarian untuk setiap baris (baris tanpa obat terpilih: " +
        tanpaKode.map(i => this.form.items.indexOf(i) + 1).join(", ") + ")";
    } else if (negatif.length) {
      this.errors.items = "Jml digunakan tidak boleh negatif";
    } else if (!dipakai.length) {
      this.errors.items = "Isi Jml Digunakan minimal pada satu obat/BMHP";
    }

    return !this.errors.indikasi && !this.errors.alergi_detail && !this.errors.items;
  }

  payload(): OrderEmergensiPayload {
    return {
      register_id: this.register,
      client_request_id: this.order ? null : this.form.client_request_id,
      lokasi_unit_id: this.order ? this.order.unit_id : this.lokasiUnitId,
      zona: userModule.user.zona || null,
      paket_id: this.form.paket_id,
      indikasi: this.form.indikasi.trim(),
      dpjp_id: this.form.dpjp_id,
      pemberi_user_id: this.form.pemberi_user_id,
      verifikator_user_id: this.form.verifikator_user_id,
      diagnosa: this.form.diagnosa || null,
      has_alergi: this.form.has_alergi,
      alergi_detail: this.form.has_alergi ? this.form.alergi_detail : null,
      catatan: this.form.catatan || null,
      items: this.form.items.map(i => ({
        id: i.id,
        paket_item_id: i.paket_item_id,
        kd_obat: i.kd_obat,
        dosis: i.dosis,
        resep_rute_id: i.resep_rute_id,
        jml_digunakan: i.jml_digunakan === "" || i.jml_digunakan === null ? null : Number(i.jml_digunakan),
        catatan: i.catatan
      }))
    };
  }

  async simpan() {
    if (this.readonly || this.saving) return;
    if (!this.validasi()) {
      appModule.sendErrorAlert(this.errors.indikasi || this.errors.alergi_detail || this.errors.items);
      return;
    }

    this.saving = true;
    try {
      const resp = this.order
        ? await OrderEmergensiSvc.update(this.order.id, this.payload())
        : await OrderEmergensiSvc.create(this.payload());
      appModule.NoticeDelay(resp.data.message || "Order emergensi tersimpan");
      this.$emit("saved", resp.data.data);
    } catch {
      this.saving = false;
      return;
    }
    this.saving = false;
  }
}
